/* Form Page to edit a Latest Post
 * Latest is a department choice in the Depts-Xtra app
   So all requests are to department */
import React, { useEffect, useRef, useState } from "react"

import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Container from "react-bootstrap/Container"
import Asset from "../../components/Asset"
import toast from "react-hot-toast";
import Upload from "../../assets/upload.png"
import styles from "../../styles/PostCreateEditForm.module.css"
import appStyles from "../../App.module.css"
import btnStyles from "../../styles/Button.module.css"
import Image from "react-bootstrap/Image"
import Alert from "react-bootstrap/Alert"

import { useHistory } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import TopBox from "../../components/TopBox"
import { useRedirect } from "../../hooks/Redirect"
import { useParams } from "react-router-dom"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"

function LatestEdit() {
  useRedirect()
  const host = useHostName()
  const [errors, setErrors] = useState({})
  const [postData, setPostData] = useState({
    title: "",
    content: "",
    departments: "",
    image1: "",
    image1Preview: null,
  })
  const { title, content, departments, 
    // eslint-disable-next-line
    image1 } = postData
  const imageInput1 = useRef(null)

  const history = useHistory()
  const { id } = useParams()

  useEffect(() => {
    /* Function to fetch the Latest post which is in the departments
           App in the latest department choice */
    const handleMount = async () => {
      try {
        const fetchContentType = async (url) => {
          const response = await fetch(url, { method: "HEAD" });
          return response.headers.get("Content-Type");
        };

        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const { data } = await axiosReq.get(`/department/posts/${id}/`)
          const { title, content, departments, image1, is_owner } = data
          const [type1] = await Promise.all([
            image1 ? fetchContentType(image1) : null,]); 
          setPostData({
            title,
            content,
            departments,
            image1,
            image1Preview: image1,
            image1Type: type1,
          })
        } else {
          const { data } = await axiosInstance.get(
            `${localStorage.getItem("projectSlug")}/department/posts/${id}/`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          )
          const { title, content, departments, image1, is_owner } = data

          const [type1] = await Promise.all([
            image1 ? fetchContentType(image1) : null,
          ]); 
          setPostData({
            title,
            content,
            departments,
            image1,
            image1Preview: image1,
            image1Type: type1,
          })
        }
      } catch (err) {
        console.log(err)
      }
    }

    handleMount()
  }, [history, id])

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
  }

  const handleChangeImage1 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (postData.image1Preview) {
        URL.revokeObjectURL(postData.image1Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image1: file,
        image1Preview: previewUrl,
        image1Type: file.type,
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData()

    formData.append("title", title)
    formData.append("content", content)
    formData.append("departments", departments)
    if (imageInput1.current.files[0]) {
      formData.append("image1", imageInput1.current.files[0])
    }

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.put(`/department/posts/${id}`, formData)
        toast.success(`Post Updated`);
        history.push(
          `/${localStorage.getItem("projectSlug")}/latest/post/${id}`
        )
      } else {
        await axiosInstance.put(
          `${localStorage.getItem("projectSlug")}/department/posts/${id}/`,
          formData,
          {
            headers: {
              /* Must stay multipart: axios converts FormData to JSON when the
               * content type says JSON, which drops the uploaded file. */
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        toast.success(`Post Updated Successfully!`);
        history.push(
          `/${localStorage.getItem("projectSlug")}/latest/post/${id}`
        )
      }
    } catch (err) {
      console.log(err)
      if (err.response?.status !== 401) {
        setErrors(err.response?.data)
      }
    }
  }

  const textFields = (
    <div>
    <Row className="mt-3">
    <Col className="d-flex justify-content-center">
    <Form.Group controlId="title" className={`${styles.Width2} text-center`}>
              <Form.Label className={`${styles.BoldScene} `} >Title</Form.Label>
              <Form.Control 
              className={styles.Input}
              type="text"
              name="title"
              value={title}
              onChange={handleChange}
                  />
    </Form.Group>
    {errors?.title?.map((message, idx) => (
      <Alert variant="warning" key={idx}>
        {message}
      </Alert>
    ))}
    </Col>
    </Row>
    <Row className="mt-4">
    <Col className="d-flex justify-content-center">
    <Form.Group controlId="content" className={`${styles.Width2} text-center`} >
    <Form.Label className={`${styles.BoldScene} `} >Content</Form.Label>
    <Form.Control 
        className={styles.InputScene}
        type="text"
        name="content"
        as="textarea"
        rows={2}
        value={content}
        onChange={handleChange}
        />
      </Form.Group>
      {errors?.content?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
    </Col>
    </Row>
    </div>
  )

  const buttons = (
    <div className="text-center">    
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      <Button className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`} type="submit">
        Update
      </Button>
    </div>
  );

  return (
    <div>
      <TopBox work="Latest Buzz" title="Edit Post" />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} my-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <h5 style={{ textTransform: 'uppercase'}} 
        className={`text-center mt-3 py-1 ${styles.SubTitle }`}>
        Edit Latest Buzz Post</h5>
      <Form className="mt-0" onSubmit={handleSubmit}>
        <Row>
          <Col md={6} className="p-0 p-md-2">
            <Container className={`${appStyles.Content} ${styles.Container}`}>
              {textFields}
            </Container>
          </Col>
          <Col className="text-center p-0 p-md-2 mt-3" md={6}>
          <p className={`${styles.BoldScene} 
                    mb-0 text-center mx-3`} >Image 1</p>
          <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
              <Form.Group>
                    {postData.image1Preview ? (
                      postData.image1Type === "application/pdf" ? (
                        <>
                          <iframe
                            src={postData.image1Preview}
                            width="40%"
                            height="100px"
                            style={{ borderRadius: 8, border: "none" }}
                            title="PDF Preview"
                          />
                          <Form.Label
                            className={`${btnStyles.Button} ${btnStyles.Blue}`}
                            htmlFor="image-upload1"
                          >
                            Change the file
                          </Form.Label>
                        </>
                      ) : (
                        <>
                          <figure>
                            <Image
                              className={appStyles.iframe}
                              width="70%"
                              height="120px"
                              src={postData.image1Preview}
                              rounded
                            />
                          </figure>
                          <Form.Label
                            className={`${btnStyles.Button} ${btnStyles.Blue}`}
                            htmlFor="image-upload1"
                          >
                            Change the image
                          </Form.Label>
                        </>
                      )
                    ) : (
                      <Form.Label
                        htmlFor="image-upload1"
                      >
                        <Asset
                            src={Upload}
                            // height={"50px"}
                            // width={"50px"}
                            message="Upload Image or PDF"
                          />
                      </Form.Label>
                    )}

                    <Form.Control
                      type="file"
                      id="image-upload1"
                      accept="image/*,.pdf"
                      onChange={handleChangeImage1}
                      ref={imageInput1}
                    />
                  </Form.Group>
                  {errors?.image1?.map((message, idx) => (
                    <Alert variant="warning" key={idx}>
                      {message}
                    </Alert>
                  ))}
          </div>
          <hr className={`d-block d-md-none`}/>
          </Col>
          </Row>
          <Row>
            <Col>
              <Container className={`${styles.Container} mt-3`}>
                {buttons}{" "}
              </Container>
            </Col>
          </Row>
      </Form>
    </div>
  )
}

export default LatestEdit
